<template>
  <collapsed-card
    :title="stage.name ? `Событие ${i + 1}: ${stage.name}` : 'Новое событие'"
    icon="md-barcode"
    style="margin-top: 16px;"
  >
    <div class="lc-editor-stage">
      <div class="lc-editor-stage__name">
        <i-input v-model="stage.name" placeholder="Название события" />
      </div>
    </div>
    <div class="lc-editor-stage__dates">
      <row :gutter="16">
        <i-col span="12">
          <span class="ms-help label">
            Начало
          </span>
          <date-picker
            format="dd.MM.yyyy"
            placeholder="Выберите дату"
            v-model="stage.start_date"
          />
        </i-col>
        <i-col span="12">
          <span class="ms-help label">
            Окончание
          </span>
          <date-picker
            format="dd.MM.yyyy"
            placeholder="Выберите дату"
            v-model="stage.end_date"
          />
        </i-col>
      </row>
    </div>
    <div class="lc-editor-stage__description">
      <span class="ms-help label">Описание</span>
      <i-input
        v-model="stage.description"
        type="textarea"
        placeholder="Описание предпринятых действий"
      />
    </div>
    <div class="lc-editor-stage__results">
      <span class="ms-help label">Результат</span>
      <i-input
        v-model="stage.result"
        type="textarea"
        placeholder="Информация о полученных результатах"
      />
    </div>

    <i-button
      slot="dropdown"
      type="text"
      class="collapsed-card-button ms-danger"
      @click="deleteHandler"
    >
      Удалить
    </i-button>
  </collapsed-card>
</template>

<script>
import CollapsedCard from '@/components/parts/collapsed-card'

export default {
  props: ['stage', 'i'],
  components: {
    CollapsedCard
  },
  methods: {
    deleteHandler (name) {
      this.$emit('delete-stage', {
        index: this.i,
        id: this.stage.id
      })
    }
  }
}
</script>

<style lang="less">
.lc-editor-stage {
  &__name {
    margin-bottom: 8px;
  }

  &__dates {
    margin-bottom: 8px;

    .ivu-date-picker {
      width: 100%;
    }
  }

  &__description {
    margin-bottom: 8px;
  }
}
</style>
